import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetDisplayWebContenetName = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (id: string, name: string) => {
      dispatch({
        type: 'UPDATE_DISPLAY_WEB_CONTENT_NAME',
        payload: {
          id,
          name,
        },
      });
    },
    [dispatch],
  );
};
